/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getMedicationDetails } from 'app/entities/medication-details/medication-details.reducer';
import { getEntities as getMedicationSchedules } from 'app/entities/medication-schedule/medication-schedule.reducer';
import { createEntity, getEntity, reset, updateEntity } from './medication-schedule-details.reducer';

export const MedicationScheduleDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const medicines = useAppSelector(state => state.medicine.entities);
  const medicationDetails = useAppSelector(state => state.medicationDetails.entities);
  const medicationSchedules = useAppSelector(state => state.medicationSchedule.entities);
  const medicationScheduleDetailsEntity = useAppSelector(state => state.medicationScheduleDetails.entity);
  const loading = useAppSelector(state => state.medicationScheduleDetails.loading);
  const updating = useAppSelector(state => state.medicationScheduleDetails.updating);
  const updateSuccess = useAppSelector(state => state.medicationScheduleDetails.updateSuccess);

  const handleClose = () => {
    navigate(`/medication-schedule-details${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getMedicines({}));
    dispatch(getMedicationDetails({}));
    dispatch(getMedicationSchedules({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...medicationScheduleDetailsEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      medicine: medicines.find(it => it.id.toString() === values.medicine?.toString()),
      medication: medicationDetails.find(it => it.id.toString() === values.medication?.toString()),
      schedule: medicationSchedules.find(it => it.id.toString() === values.schedule?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...medicationScheduleDetailsEntity,
          glucoUser: medicationScheduleDetailsEntity?.glucoUser?.id,
          medicine: medicationScheduleDetailsEntity?.medicine?.id,
          medication: medicationScheduleDetailsEntity?.medication?.id,
          schedule: medicationScheduleDetailsEntity?.schedule?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.medicationScheduleDetails.home.createOrEditLabel" data-cy="MedicationScheduleDetailsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.home.createOrEditLabel">
              Create or edit a MedicationScheduleDetails
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="medication-schedule-details-id"
                  label={translate('tinyMedicRestApp.medicationScheduleDetails.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.dose')}
                id="medication-schedule-details-dose"
                name="dose"
                data-cy="dose"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.active')}
                id="medication-schedule-details-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.timestampentry')}
                id="medication-schedule-details-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.lastupdated')}
                id="medication-schedule-details-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.cursor')}
                id="medication-schedule-details-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.medicationScheduleDetails.microSec')}
                id="medication-schedule-details-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="medication-schedule-details-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.medicationScheduleDetails.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-schedule-details-medicine"
                name="medicine"
                data-cy="medicine"
                label={translate('tinyMedicRestApp.medicationScheduleDetails.medicine')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-schedule-details-medication"
                name="medication"
                data-cy="medication"
                label={translate('tinyMedicRestApp.medicationScheduleDetails.medication')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicationDetails
                  ? medicationDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="medication-schedule-details-schedule"
                name="schedule"
                data-cy="schedule"
                label={translate('tinyMedicRestApp.medicationScheduleDetails.schedule')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicationSchedules
                  ? medicationSchedules.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/medication-schedule-details" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MedicationScheduleDetailsUpdate;
